import api from './api';
import {
  Transfer,
  FormSubmission,
  FormSubmissionStatus,
  FormSubmissionStats,
  ApproveFormSubmissionData,
} from '../types';

export const formSubmissionsService = {
  async getAll(status?: FormSubmissionStatus): Promise<FormSubmission[]> {
    const params = status ? `?status=${status}` : '';
    const response = await api.get<FormSubmission[]>(`/form-submissions${params}`);
    return response.data;
  },

  async getStats(): Promise<FormSubmissionStats> {
    const response = await api.get<FormSubmissionStats>('/form-submissions/stats');
    return response.data;
  },

  async getById(id: string): Promise<FormSubmission> {
    const response = await api.get<FormSubmission>(`/form-submissions/${id}`);
    return response.data;
  },

  async approve(
    id: string,
    data: ApproveFormSubmissionData,
  ): Promise<{ submission: FormSubmission; transfer: Transfer }> {
    const response = await api.post(`/form-submissions/${id}/approve`, data);
    return response.data;
  },

  async reject(
    id: string,
    rejectionReason?: string,
  ): Promise<FormSubmission> {
    const response = await api.post(`/form-submissions/${id}/reject`, {
      rejectionReason,
    });
    return response.data;
  },

  async retryTransfer(id: string): Promise<{ submission: FormSubmission; transfer: Transfer }> {
    const response = await api.post(`/form-submissions/${id}/retry-transfer`);
    return response.data;
  },

};
